<template>
  <div>
    <ul uk-accordion>
      <li class="">
        <a class="uk-accordion-title" href="#">Пример ОС на платформе</a>
        <div class="uk-accordion-content">
          <p>Добрый день, { имя родителя }! Обратная связь по занятию ментальной арифметике, тренер { имя тренера }</p>
          <p>На занятии мы изучали тему "{ тема занятия }", научились набирать числа с десятками на абакусе, продолжали развивать фотографическую память (логику, мышление) выполняя тренажеры { названия и параметры тренажеров }.</p>
          <p>На занятии по ментальной арифметике мы постепенно решаем нашу общую задачу - формировать и закрепить навык самостоятельности у { имя ученика }. Чтобы развивать и закреплять этот навык самостоятельности мы выполнили такие задания как: Флэш-карты - это тренажер, который развивает короткую и долгую память и скорость реакции ребят, чтобы { имя ученика } в школе учился быстро запоминать необходимую информацию ( стихи, правила, тексты). Тренер каждый раз пишет про разные тренажеры</p>
          <p>Очень хочу похвалить { имя ученика }! На занятиях справляется отлично, старается очень! Приятно видеть его вовлеченность и интерес на уроке!</p>
          <p>{ имя ученика } похвалился, что в школе есть изменения ( акцент на то, как и где в жизни увидеть). Молодцы!!!</p>
          <p>Для закрепления навыка { навык } и решения задачи { боли } было бы отлично с утра после завтрака или перед выполнением домашнего задания по школе выполнить фундаментальный тренажер (читать книжку под разными углами 20 мин в день по СЧ), чтобы активизировать концентрацию внимания, чтобы меньше ошибок совершать и быстрее дом задание выполнить. </p>
          <p>Благодарим за поддержку в выполнении тренажеров на платформе!!! 4-5 раз в неделю по 10 мин - отличная зарядка для мозга и собрать ребенка , чтобы быстро и качественно дом задание выполнять.</p>
          <p>Выполнение домашнего задание систематически &ndash; залог результативности методики развития психических процессов мозга.</p>
          <p>Спасибо за совместную работу! Ваша поддержка играет огромную роль в достижении заветных целей!</p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "feedback-example",
  props: {
    items: ''
  }
}
</script>